// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../../../../schema/public';

import { gql } from '@apollo/client';
import { MyClappsFragmentDoc, ClappsFragmentDoc } from './ClappsQuery.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClappForGameMutationVariables = Types.Exact<{
  input: Types.CasinoVoteForGameInput;
}>;


export type ClappForGameMutation = { __typename?: 'Mutation', casinoVoteForGame?: { __typename?: 'CasinoVoteForGamePayload', myClapps?: { __typename?: 'CasinoMyVote', id: string, myRating?: Types.RatingEnum }, allClapps?: { __typename?: 'CasinoVotes', id: string, clapps: number } } };


export const ClappForGameMutationDocument = /*#__PURE__*/ gql`
    mutation ClappForGameMutation($input: CasinoVoteForGameInput!) {
  casinoVoteForGame(input: $input) {
    myClapps: myVote {
      ...MyClappsFragment
    }
    allClapps: votes {
      ...ClappsFragment
    }
  }
}
    ${MyClappsFragmentDoc}
${ClappsFragmentDoc}`;
export type ClappForGameMutationMutationFn = Apollo.MutationFunction<ClappForGameMutation, ClappForGameMutationVariables>;
export function useClappForGameMutation(baseOptions?: Apollo.MutationHookOptions<ClappForGameMutation, ClappForGameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClappForGameMutation, ClappForGameMutationVariables>(ClappForGameMutationDocument, options);
      }
export type ClappForGameMutationHookResult = ReturnType<typeof useClappForGameMutation>;
export type ClappForGameMutationMutationResult = Apollo.MutationResult<ClappForGameMutation>;
export type ClappForGameMutationMutationOptions = Apollo.BaseMutationOptions<ClappForGameMutation, ClappForGameMutationVariables>;